module.exports = __webpack_public_path__ + "img/arrow-up-circle.20368ee1.svg";